import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { reactRender } from 'reusable/react-render/react-render'
import CssBaseline from "@mui/material/CssBaseline"
import { modalConfig } from './modal-theme'
import GapDialog, { GapDialogProps } from 'reusable/gap-dialog/GapDialog'
import { GapDialogAction } from 'reusable/gap-dialog/GapDialogActionButton'
import ModalState from 'reusable/mobx-helpers/ModalState'

/** shows dialog for user with different buttons/actions */
export const messageActions = async (options: GapDialogProps) =>
   new Promise<GapDialogAction>((resolve) => {
      reactRender((container, root) => {
         const modalState = new ModalState({
            initial: true,
            onClose: () => {
               root.unmount()
            }
         })

         return <StyledEngineProvider injectFirst>
            <ThemeProvider theme={modalConfig.theme}>
               <CssBaseline />
               <GapDialog modalState={modalState} size='extra small' {...options} resolve={resolve} >{options.children}</GapDialog>
            </ThemeProvider>
         </StyledEngineProvider>
      })
   })
